import { render, staticRenderFns } from "./RecentKeywordsSection.vue?vue&type=template&id=7ec384f5&scoped=true&lang=pug"
import script from "./RecentKeywordsSection.vue?vue&type=script&lang=js"
export * from "./RecentKeywordsSection.vue?vue&type=script&lang=js"
import style0 from "./RecentKeywordsSection.vue?vue&type=style&index=0&id=7ec384f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec384f5",
  null
  
)

export default component.exports